export const gameFeed = {
  gameFeed: "游戏动态",
  gameFeedTitle: "游戏动态",
  gameFeedLoading: "正在加载游戏...",
  gameFeedLike: "喜欢",
  gameFeedUnlike: "取消喜欢",
  gameFeedLikeSingular: "喜欢",
  gameFeedLikePlural: "喜欢",
  gameFeedComments: "评论",
  gameFeedNoComments: "还没有评论，快来第一个评论吧！",
  gameFeedAddComment: "添加评论...",
  gameFeedCommentModerated: "您的评论未发布，因为它违反了平台政策。请保持评论尊重。",
  gameFeedCommentSupportRedirect: "如有提款或付款问题，请联系我们的客服团队。此区域仅用于游戏评论。",
  gameFeedPost: "发布",
  gameFeedDelete: "删除",
  gameFeedLoginToComment: "登录后评论",
  gameFeedLoginToLike: "登录后点赞",
  gameFeedReply: "回复",
  gameFeedReplyPlaceholder: "写一条回复...",
  gameFeedViewReplies: "查看回复 ({{count}})",
  gameFeedViewMoreReplies: "查看更多回复",
  gameFeedHideReplies: "收起回复",
  gameFeedEndOfFeed: "你已经看完了所有游戏！",
  gameFeedCloseGame: "关闭游戏",
  gameFeedExpandGame: "全屏显示游戏",
  gameFeedDeposit: "充值",
  gameFeedBadgeHot: "热门",
  gameFeedBadgeNew: "最新",
  gameFeedBadgeBigWinner: "大奖",
  providerProfileBack: "返回",
  providerProfileGames: "游戏",
  providerProfileFollowers: "关注者",
  providerProfileFollow: "关注",
  providerProfileFollowing: "已关注",
  providerProfileGridView: "网格视图",
  providerProfileListView: "列表视图",
  providerProfileNoGames: "该提供商暂无可用游戏。",
  providerProfileClose: "关闭",
  providerProfilePlayGame: "开始游戏",
};
